import { render, staticRenderFns } from "./succese.vue?vue&type=template&id=2de2d9c4&scoped=true&"
import script from "./succese.vue?vue&type=script&lang=js&"
export * from "./succese.vue?vue&type=script&lang=js&"
import style0 from "./succese.vue?vue&type=style&index=0&id=2de2d9c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de2d9c4",
  null
  
)

export default component.exports